import {AiOutlineStar} from "react-icons/ai";
import React, {useEffect, useRef, useState} from "react";
import {GiSandsOfTime} from "react-icons/gi";
import LightBulb from "./../../../../assets/img/lightBulb.svg"
import MagnifyingGlass from "./../../../../assets/img/magnifyingGlass.svg"
import Star from "./../../../../assets/img/star.svg"
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import TestedDateModal from "../../../../Modals/tested-date-modal/tested-date-modal";
import {Link} from "react-router-dom";
import PracticeAnalysisQuestions from "../../../../utils/pratice-analysis-quesstions";
import {markQuestion} from "../variables/PracticePageFilter";
import StarsFilter from "../../../../components/Filter/stars-filter";
import axiosInstance from "../../../../API/Axios/AxiosConfig";
import URLS from "../../../../API/Axios/URLS";
import {toast} from "react-toastify";

export default function QuestionHeader({
                                           className,
                                           title,
                                           name,
                                           QuestionNumber,
                                           timeInSeconds,
                                           onTimerComplete,
                                           tested,
                                           num,
                                           isPracticed,
                                           difficulty,
                                           timeLimit,
                                           ...props
                                       }) {

    const [time, setTime] = useState(parseInt( timeLimit / 1000));
    const interval = useRef(null)
    const {question} = useQuestion()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [testedCount, setTestedCount] = useState(tested || 0)
    const [mark, setMark] = useState(props.metaData?.marker?.marker || "-1")

    let MarkerFilter = {
        ...markQuestion,
        options: [
            {
                value: "-1",
                name: <img src={Star} className={"w-6 h-6"} alt={"Star"}/>
            }
            , ...markQuestion.options
        ]
    }

    function onTimeComplete() {
        if (onTimerComplete) onTimerComplete();
        let mysubmit = document.getElementById("submit-question-button");
        if (mysubmit) {
            mysubmit.disabled = true;

        }
        toast.info("Times up",{
            toastId:"time-up"
        })
    }
    const isFirstRender = useRef(true);
    useEffect(() => {
        setTime(parseInt( timeLimit / 1000))
    }, [])
    useEffect(() => {
        setTime(parseInt( timeLimit / 1000))
    }, [question])
    useEffect(() => {
        if (time !== 0) return;
        clearInterval(interval.current);
        // onTimeComplete();
    }, [time, question]);
    useEffect(() => {
        if (!timeLimit) return;
        interval.current = setInterval(() => {
            setTime(prev =>{
                let newTime = prev - 1;
                if (newTime <= 0) {
                    newTime = 0;
                    onTimeComplete()
                }
                return newTime
            })
        }, 1000);

        return () => {
            clearInterval(interval.current);

        }

    }, [question,]);

    useEffect(() => {
        setTestedCount(tested)
        setMark(props?.metaData?.marker?.marker || "-1")
    }, [tested, props?.metaData?.marker?.marker])

    function getTimeFormate() {
        //     min:sec
        let min = Math.floor(time / 60);
        let sec = time % 60;
        sec = sec < 10 ? `0${sec}` : sec;
        return `${min}:${sec}`
    }


    function markQuestionApi(newMark) {
        let prevMark = mark;
        setMark(newMark)
        axiosInstance.post(URLS.markQuestion, {
            question: props?.id,
            marker: newMark
        }).catch((error) => {
            toast.error("Failed to mark question");
            setMark(prevMark)
        })

    }

    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            <TestedDateModal isOpen={isModalOpen} questionId={props?.id}
                             onSuccess={(data) => {
                                 setTestedCount(data?.count)
                             }}
                             setOpen={setIsModalOpen}/>
            {/*Upper header*/}
            <div
                className={`cursor-pointer flex flex-row flex-wrap md:flex-row gap-4 justify-center items-center rounded-md w-full py-3 px-4   ${className}`}>
                <p className={" flex-1 font-bold whitespace-nowrap text-sm lg:text-xl"}>
                    #{props?.id} {name}
                </p>
                <div className={"flex flex-row gap-4"}>
                    <div className={"flex  gap-4 flex-row"}>
                        <p className={"rounded-md hidden md:flex text-secondary-900 text-xs whitespace-nowrap lg:text-sm font-semibold  p-1 border-[1px] border-secondary-900"}>
                            {difficulty === "easy" ? "Easy ≤95" : ""}
                            {difficulty === "medium" ? "Medium 100-125" : ""}
                            {difficulty === "hard" ? "Hard ≥130" : ""}
                        </p>
                        <p className={"rounded-md text-tertiary-900 text-xs whitespace-nowrap lg:text-sm font-semibold  p-1 border-[1px] border-tertiary-900"}>
                            {props.metaData?.total}
                        </p>
                        <p className={"rounded-md text-xs lg:text-sm font-semibold text-gray-400 p-1 border-[1px] border-gray-300"}>
                            {
                                props.metaData?.practiced?.lastPracticed ? "Practiced" : "Not Practiced"
                            }
                        </p>
                    </div>
                    <div className={"hidden lg:flex flex-1"}/>
                    <div className={"flex flex-row gap-4 mr-6 justify-center items-center"}>
                        {/*<img src={LightBulb} className={"w-7 h-7"} alt={"LightBulb"}/>*/}
                        {
                            PracticeAnalysisQuestions.includes(props?.category?.type) &&
                            <Link className={'hidden lg:flex'} to={"/tools/practice-analysis/" + props?.category?.type}>
                                <img title={"Practice analysis"} src={MagnifyingGlass} className={"w-6 h-6"}
                                     alt={"MagnifyingGlass"}/>
                            </Link>
                        }
                        <StarsFilter
                            currentValue={mark}
                            select={(value) => {
                                markQuestionApi(value?.mark)
                            }}
                            {
                                ...MarkerFilter
                            }
                        />
                        <div onClick={() => setIsModalOpen(true)}
                             className={"flex border-[1px] border-tertiary-900 rounded-md  px-2 cursor-pointer  gap-4  justify-center items-center flex-row"}>
                            <p className={"font-semibold text-lg text-tertiary-900 "}>
                                Tested x {testedCount}
                            </p>
                        </div>
                    </div>

                </div>


            </div>
            <div className={"flex px-4 flex-1 text-xl text-primary-500"}>
                {title}
            </div>

            <div className={"line"}/>

            <div className={"flex flex-row"}>
                <div className={"flex  flex-row gap-2  text-4xl  justify-center items-center"}>
                    <GiSandsOfTime className={"text-gray-400 rotate-spinner"}/>
                    <p className={"font-bold "}>
                        {getTimeFormate()}
                    </p>
                </div>
                <div className={"flex-1"}/>


            </div>


        </div>

    )
}
